<div class="loader" *ngIf="showSpinner"></div>
<div class="no-loader" *ngIf="!showSpinner"></div>